'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('./../../utils/formatting');

var _colors = require('../../utils/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lineWrapper = {
  height: 210,
  minHeight: 210,
  padding: 0,
  display: 'flex',
  alignItems: 'flex-end'
};

var getValue = function getValue(value, sum) {
  return 100 * value / sum;
};

var getLineStyle = function getLineStyle(value, sum) {
  return {
    height: getValue(value, sum) + '%',
    background: _colors.dyzioPalette.pink,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '200px',
    margin: '0 auto',
    borderRight: '25px solid white',
    borderLeft: '25px solid white',
    textAlign: 'center',
    borderRadius: '10px 10px 0 0',
    fontWeight: 'bold',
    color: 'white'
  };
};

var getImpressionsLineStyle = function getImpressionsLineStyle(value, sum) {
  return {
    height: getValue(value, sum) + '%',
    background: _colors.dyzioPalette.blue,
    display: 'flex',
    width: '100%',
    maxWidth: '200px',
    margin: '0',
    borderLeft: '25px solid white',
    textAlign: 'center',
    // borderRadius: '10px 10px 0 0',
    fontWeight: 'bold',
    color: 'white'
  };
};

var getReachLineStyle = function getReachLineStyle(value, sum) {
  return {
    height: getValue(value, sum) + '%',
    background: _colors.dyzioPalette.green,
    display: 'flex',
    width: '100%',
    maxWidth: '200px',
    margin: '0',
    borderRight: '25px solid white',
    textAlign: 'center',
    // borderRadius: '10px 10px 0 0',
    fontWeight: 'bold',
    color: 'white'
  };
};

var gridStyle = {
  maxWidth: '800px',
  margin: '0 auto'
};

var avatarStyle = {
  margin: '0 auto',
  display: 'block',
  width: '52px'
};

var labelDIVStyle = {
  display: 'flex'
};

var noTopBottomPadding = {
  paddingTop: 0,
  paddingBottom: 0
};

var noTop100BottomPadding = {
  paddingTop: 0,
  paddingBottom: '100px'
};

var valueLabelStyle = {
  fontWeight: 'bold',
  paddingTop: 5,
  color: '#444'
};

var handleStyle = {
  color: '#555',
  transform: 'translateY(100%) rotate(-45deg)',
  margin: '0'
};

var DyzioBarChart = function DyzioBarChart(_ref) {
  var options = _ref.options;

  //
  var sum = _lodash2.default.sumBy(options, function (row) {
    console.log(row);
    var value = _lodash2.default.get(row, row.chartType);
    return _lodash2.default.gt(_lodash2.default.toNumber(value), 0) ? value : 0;
  });
  var sortedRows = _lodash2.default.orderBy(options, function (row) {
    var value = _lodash2.default.get(row, row.chartType);
    return _lodash2.default.toNumber(value) > 0 ? value : 0;
  }, ['desc']);

  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { textAlign: 'center', columns: _lodash2.default.size(sortedRows), style: gridStyle },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { style: noTopBottomPadding },
      _lodash2.default.map(sortedRows, function (option) {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          {
            style: lineWrapper
          },
          _lodash2.default.isEqual(option.chartType, 'engagementsRate') && _react2.default.createElement(
            'div',
            { style: getLineStyle(option.engagementsRate, sum) },
            _react2.default.createElement('div', { style: labelDIVStyle })
          ),
          _lodash2.default.isEqual(option.chartType, 'impressions') && _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              'div',
              { style: getImpressionsLineStyle(option.impressions, sum) },
              _react2.default.createElement('div', { style: labelDIVStyle })
            ),
            content: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                _lodash2.default.get(option, 'handle')
              ),
              _react2.default.createElement('br', null),
              'Impressions: ',
              (0, _formatting.sciFormatted)(_lodash2.default.get(option, 'impressions'))
            )
          }),
          _lodash2.default.isEqual(option.chartType, 'impressions') && _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              'div',
              { style: getReachLineStyle(option.reach, sum) },
              _react2.default.createElement('div', { style: labelDIVStyle })
            ),
            content: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                _lodash2.default.get(option, 'handle')
              ),
              _react2.default.createElement('br', null),
              'Reach: ',
              (0, _formatting.sciFormatted)(_lodash2.default.get(option, 'reach'))
            )
          })
        );
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { style: noTop100BottomPadding },
      _lodash2.default.map(sortedRows, function (option) {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(
            'div',
            { style: valueLabelStyle },
            _lodash2.default.gt(_lodash2.default.toNumber(_lodash2.default.get(option, 'engagementsRate')), 0) && _lodash2.default.isEqual(option.chartType, 'engagementsRate') ? _lodash2.default.get(option, 'engagementsRate').toFixed(2) + '%' : ' '
          ),
          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
          _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(_semanticUiReact.Image, {
              style: avatarStyle,
              size: 'tiny',
              className: 'circular',
              src: _lodash2.default.get(option, 'imageURL')
            }),
            content: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                _lodash2.default.get(option, 'handle')
              ),
              _react2.default.createElement('br', null),
              (0, _formatting.sciFormatted)(_lodash2.default.get(_lodash2.default.get(option, 'totals'), 'followersCount')),
              ' followers'
            )
          }),
          _react2.default.createElement(
            'h4',
            { style: handleStyle },
            _lodash2.default.truncate(_lodash2.default.get(option, 'handle'), { length: 14 })
          )
        );
      })
    )
  );
};

DyzioBarChart.propTypes = {
  options: _propTypes2.default.arrayOf.isRequired
};

exports.default = DyzioBarChart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/components/dyzio-bar-chart/index.js
// module id = 1070
// module chunks = 1